import { AlertTriangle } from "lucide-react";
import { Modal } from "./modal";

export function ConfirmModal({ title, body, confirmLabel = "Confirm", onConfirm, onClose }: {
  title: string; body: string; confirmLabel?: string; onConfirm: () => void; onClose: () => void;
}) {
  return (
    <Modal
      title={title}
      onClose={onClose}
      width="max-w-sm"
      footer={
        <>
          <button onClick={onClose} className="rounded-lg border border-line px-4 py-2 text-sm font-semibold text-ink hover:bg-soft">
            Cancel
          </button>
          <button onClick={onConfirm} className="rounded-lg bg-danger px-4 py-2 text-sm font-semibold text-white hover:bg-[#b42318]">
            {confirmLabel}
          </button>
        </>
      }
    >
      <div className="flex items-start gap-3">
        <span className="rounded-lg bg-danger-soft p-2 text-danger"><AlertTriangle className="h-4 w-4" /></span>
        <p className="text-sm leading-relaxed text-ink-2">{body}</p>
      </div>
    </Modal>
  );
}
